// extracted by mini-css-extract-plugin
export var lightMode = "_15-0";